export const addNewsletterSignupAnalytics = (
  siteName,
  status,
  message,
  internalLink = true
) => {
  if (window.adobeDataLayer) {
    const { adobeDataLayer: { getState } = {} } = window
    const eventInfo = {
      "@type": siteName?.toLowerCase() + "/components/newslettersignin",
      eventMsg: message || "n/a",
      eventStatus: status,
      clickInternalLinks: `${internalLink}`,
      internalLinkPosition: "newslettersignin",
      internalLinkZoneName: "global footer",
      internalLinkURL: "n/a",
      internalLinkName: "newsletter submit",
      eventName: "newsletter submit",
      internalLinkType: "global footer:submit",
      eventType: "click",
      eventAction: "newsletter submit",
    }
    const page = (getState && getState("page")) || {}
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo: eventInfo,
      page: page,
    })
  }
}
export const subModalAnalytics = (msg, hreflink, internalLink = true) => {
  if (window.adobeDataLayer) {
    const { adobeDataLayer: { getState } = {} } = window
    const eventInfo = {
      eventMsg: "n/a",
      eventStatus: "n/a",
      clickInternalLinks: `${internalLink}`,
      internalLinkPosition: "newsletter:signin complete",
      internalLinkZoneName: "newsletter submit:get ready",
      internalLinkURL: hreflink ? msg + hreflink : "n/a",
      internalLinkName: msg,
      eventName: `newsletter submit:get ready:${msg}`,
      internalLinkType: "newsletter submit:get ready",
      eventType: "navigation",
      eventAction: `newsletter submit:get ready:${msg}`,
    }
    const page = (getState && getState("page")) || {}
    window.adobeDataLayer.push({
      event: "cmp:click",
      eventInfo: eventInfo,
      page: page,
    })
  }
}
